import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import { StatusChip } from "components/StatusChip";

interface NeedsReviewCellProps {
  /** AI-ingested manifest documents on this manifest still awaiting human review. */
  documentCount: number;
  /**
   * True when a needs-review document has no reviewer yet (server-derived from the
   * document's own assignment state). Gating on this rather than the manifest's derived
   * assignee keeps the chip honest when a discrepancy is assigned but the document isn't.
   */
  reviewPending: boolean;
}

/**
 * Flags a manifest whose document review still needs an owner. Orange (warning) per the
 * page's status color rule — unassigned review work, like an unresolved discrepancy.
 * Hidden once the document review is assigned (in flight) or complete: the assignee/status
 * columns tell that story, so this column stays a scannable "docs needing an owner" list.
 */
export function NeedsReviewCell({ documentCount, reviewPending }: NeedsReviewCellProps) {
  if (documentCount <= 0 || !reviewPending) return null;
  return (
    <StatusChip
      variant="outlined"
      color="warning"
      icon={<DescriptionOutlined />}
      label={documentCount > 1 ? `Needs review (${documentCount})` : "Needs review"}
    />
  );
}
